import api from "services/api/Api";
import { ApiPaths } from "services/api/ApiPaths";
import ValidateApiSchema from "services/validators/ValidateApiSchema";
import { TCreateScenario, TScenarios, TSubmitResponse, scenariosSchema, submitResponseSchema ,TDeletePracticeResponse, DeletePracticeResponse, TPublishScenario,  publishScenrioDetails  } from "../scenario.model";
import { z } from "zod";
import { DEVELOPER, WRITER } from "components/user/RolesConfig";

//Scenario
export const loadScenarios = async (userRole: string): Promise<TScenarios> => {
    let elevatedUser = false;
    if(userRole === DEVELOPER || userRole=== WRITER) {
        elevatedUser = true;
    }
    const response =  await api.get(`${ApiPaths.SCENARIO}?isElevatedUser=${elevatedUser}`);    
    return ValidateApiSchema(response, scenariosSchema)
}

export const createScenario = async (data: TCreateScenario): Promise<boolean> => {
    const response =  await api.post(ApiPaths.SCENARIO, data);
    return ValidateApiSchema(response, z.boolean())
}

export const deleteScenario = async (id: number): Promise<boolean> => {
    const response =  await api.delete(ApiPaths.SCENARIO + id )
    return ValidateApiSchema(response, z.boolean())
}
export const updateScenario = async (id: number, data: TCreateScenario): Promise<boolean> => {
    const response =  await api.put(ApiPaths.SCENARIO + id, data );
    return ValidateApiSchema(response, z.boolean());
}

//Start/Review
export const startScenario = async (id: number, isReview: boolean): Promise<number> => {
    const response =  await api.post(ApiPaths.USER_SCENARIO + id + `?isReview=${isReview}`, {} )
    return ValidateApiSchema(response, z.number())
}

export const deleteUserScenario = async (id: number): Promise<boolean> => {
    const response =  await api.delete(ApiPaths.USER_SCENARIO + id )
    return ValidateApiSchema(response, z.boolean())
}

export const loadPractice = async (): Promise<number> => {
    const response =  await api.get(ApiPaths.PRACTICE)
    return ValidateApiSchema(response, z.number())
}

export const deletePractice = async (): Promise<TDeletePracticeResponse> => {
    const response =  await api.delete(ApiPaths.PRACTICE)
    return ValidateApiSchema(response, DeletePracticeResponse)
}

export const submitScenario = async (id: number): Promise<TSubmitResponse> => {
    const response =  await api.put(ApiPaths.SUBMIT + id)
    return ValidateApiSchema(response, submitResponseSchema)
}

export const publishScenario = async (id: number, isPublished: boolean): Promise<TPublishScenario> => {
    const response =  await api.put(ApiPaths.PUBLISH_SCENARIO + id, {isPublished})
    return ValidateApiSchema(response, publishScenrioDetails)
}